import { DocumentationPageContent } from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTODocumentationPageContent = DocumentationPageContent;

export const DTODocumentationPageContentGetResponse = z.object({
  pageContent: DTODocumentationPageContent,
});

export type DTODocumentationPageContent = z.infer<typeof DTODocumentationPageContent>;
export type DTODocumentationPageContentGetResponse = z.infer<typeof DTODocumentationPageContentGetResponse>;
